import React from 'react';
import { useConfiguration } from '../../context/configuration-context/use-configuration';
const Component = React.lazy(() => import(/* webpackChunkName: "wc-ricos-editor" */ './ricos-editor'));
const RicosEditorLazy = (props) => {
    const isSSR = typeof window === 'undefined';
    const { pluginConfig } = useConfiguration();
    const [editorPluginConfig, setEditorPluginConfig] = React.useState({});
    const editorPluginPromise = React.useMemo(async () => {
        if (pluginConfig && pluginConfig.type === 'sync') {
            setEditorPluginConfig(pluginConfig);
        }
        if (pluginConfig && pluginConfig.type === 'async') {
            pluginConfig.loadEditorPluginsAsync().then(setEditorPluginConfig);
        }
    }, [pluginConfig]);
    return isSSR ? null : (React.createElement(React.Suspense, { fallback: props.fallback ?? null },
        React.createElement(Component, { ...props, pluginConfig: pluginConfig?.type === 'async'
                ? {
                    type: 'async',
                    plugins: editorPluginConfig,
                    onLoadFinished: (cb) => {
                        editorPluginPromise.then(cb);
                    },
                }
                : { type: 'sync', plugins: pluginConfig } })));
};
export default RicosEditorLazy;
//# sourceMappingURL=ricos-editor-lazy.js.map